type Group<Resource = any> = {
  name: string;
  description: string;
  resourceType: string;
  resources: Resource[];
};

const group: Group = {
  name: "",
  description: "",
  resourceType: "",
  resources: [],
};

export type { Group };

export { group };
